<p-panel>
  <app-reactive-form-builder
    [form]="form.formFields"
    [id]="reactiveFormRecordId"
    [request]="request"
    [getRequest]="getRequest"
    [undoEnabled]="undoEnabled"
    (goBack)="goBack()">
  </app-reactive-form-builder>
</p-panel>
